import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCContrato } from "../../infrastructure/services/api/SVCContrato";

import IViewContrato from "../../presentation/view-interfaces/IViewContrato";

export const ObtieneContrato = (selListaContrato: any, headers: any,
    codigoNegocio: number,
    codigoPrograma: string,
    rut: number, download: boolean, agnoPromocion: number, codigoPlanificacionAcademica: number, incluirFirmaUDD: boolean, idPeriodo: number, idPersona: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneContrato(headers, codigoNegocio, codigoPrograma, rut, download, agnoPromocion, codigoPlanificacionAcademica, incluirFirmaUDD, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            list.push({
                file: data
            });

            selListaContrato(false, '', list);
        } else {
            selListaContrato(true, res.errorDetails, list);
        }
    });
}

// export const ObtieneContratoPDF = (selListaContrato: any,
//     codigoNegocio: number,
//     codigoPrograma: string,
//     rut: number, download: boolean) => {
//     let list: Array<IViewContrato> = [];
//     SVCContrato.ObtieneContratoPDF(codigoNegocio, codigoPrograma, rut, download).then((res: any) => {
//         selListaContrato(false, '', list);
//         /* 
//         if (res.result !== undefined){
//             let data:any = res.result;
//             list.push({
//                 file: data
//             });
//         }else{
//             selListaContrato(true,'error',list);
//         }*/
//     });
// }

export const EstadoFirmaEcert = (selListaEstado: any,
    rut: number,
    codigoPrograma: string,
    estado: boolean) => {
    let list: any = [];
    SVCContrato.EstadoFirmaEcert(
        rut,
        codigoPrograma,
        estado).then((res: any) => {
            selListaEstado(false, '', list);
            /* 
            if (res.result !== undefined){
                let data:any = res.result;
                list.push({
                    file: data
                });
            }else{
                selListaContrato(true,'error',list);
            }*/
        });
}
export const eCert_firma = (selListaContrato: any,
    idProceso: number,
    rut: number,
    anoPromocion: number,
    periodoPromocion: number,
    numeroAlumno: string,
    tipoPersona: number,
    idPeriodo: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.eCert_firma(idProceso,
        rut,
        anoPromocion,
        periodoPromocion,
        numeroAlumno,
        tipoPersona,
        idPeriodo).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContrato(false, '', data,);
            } else {
                selListaContrato(true, res.errorDetails, list,);
            }
        });
}
export const ObtenerFirma = (selObtenerFirma: any,
    codigoNegocio: number, idProceso: number, idPeriodo: number, esMenorEdad: boolean, idRefirma: number) => {
    let list: Array<IViewContrato> = [];
    setTimeout(() => {
        SVCContrato.ObtieneFirma(codigoNegocio, idProceso, idPeriodo, esMenorEdad, idRefirma).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selObtenerFirma(false, '', data);
            } else {
                selObtenerFirma(true, res.errorDetails, list);
            }
        });
    }, 3000)

}
export const EnviarToken = (selObtenerFirma: any,
    token: string, codigo: string) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.EnviarToken(token, codigo).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            //console.log(data)
            selObtenerFirma(false, '', data,);
        } else {
            selObtenerFirma(true, res.errorDetails, list,);
        }
    });
}
export const ObtieneExcepcion = (selObtenerFirma: any,
    rut: number,
    codigoExcepcion: number,
    codigoNegocio: number,
    anio: number,
    periodo: number,
    codigoPrograma: string) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneExcepcion(rut, codigoExcepcion, codigoNegocio, anio, periodo, codigoPrograma).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            //console.log(data)
            selObtenerFirma(false, '', data);
        } else {
            selObtenerFirma(true, res.errorDetails, list);
        }
    });
}
export const ObtieneExcepcionPrograma = (selObtenerFirmaPrograma: any,
    codigoExcepcion: number,
    codigoNegocio: number,
    codigoCarrera: string,
    anio: number,
    periodo: number,
    codigoPlanificacion: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneExcepcionPrograma(codigoExcepcion, codigoNegocio, codigoCarrera, anio, periodo, codigoPlanificacion).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            //console.log(data)
            selObtenerFirmaPrograma(false, '', data);
        } else {
            selObtenerFirmaPrograma(true, res.errorDetails, list,);
        }
    });
}

export const ObtieneContratoManual = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneContratoManual(rut,
        idProceso).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
export const ObtieneContratoWeb = (selListaContratoManual: any,
    rut: number,
    codCarrera: string) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneContratoWeb(rut,
        codCarrera).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
export const BajarContratoManual = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.BajarContratoManual(rut,
        idProceso).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
export const BajarContrato = (selListaContratoManual: any,
    rut: number,
    codCarrera: string) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.BajarContrato(rut,
        codCarrera).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
export const InsertaContratoManual = (selListaContratoManual: any,
    rut: number,
    idProceso: number,
    anoPromocion: number,
    periodoPromocion: number,
    numeroAlumno: string,
    base64: string,
    idPeriodo: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.InsertaContratoManual(rut,
        idProceso, anoPromocion, periodoPromocion, numeroAlumno, base64, idPeriodo).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
export const QuitarContratoManual = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    let list: Array<IViewContrato> = [];
    SVCContrato.QuitarContratoManual(rut,
        idProceso).then((res: any) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                //console.log(data)
                selListaContratoManual(false, '', data);
            } else {
                selListaContratoManual(true, res.errorDetails, list,);
            }
        });
}
// export const ObtenerFirmaContrato = (selListaFirmaContrato: any,
//     rut: number,
//     codCarrera: string,
//     codigoPlanificacion: number) => {
//     let list: Array<IViewContrato> = [];
//     SVCContrato.ObtenerFirmaContrato(rut,
//         codCarrera, codigoPlanificacion).then((res: any) => {
//             if (res.result !== undefined) {
//                 let data: any = res.result;
//                 //console.log(data)
//                 selListaFirmaContrato(false, '', data);
//             } else {
//                 selListaFirmaContrato(true, res.errorDetails, list);
//             }
//         });
// }

export const ObtieneTieneFirmaContrato = (selListaTieneFirmaContrato: any,
    codigoNegocio: number,
    rut: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number) => {
    //let list: Array<IViewContrato> = [];
    SVCContrato.ObtieneTieneFirmaContrato(codigoNegocio, rut,
        codigoPrograma, anioPromocion, periodoPromocion, codigoPlanificacion).then((res: any) => {
            if (res.result !== undefined) {
                //let data: any = res.result;
                //console.log(data)
                selListaTieneFirmaContrato(false, '', res.result);
            } else {
                selListaTieneFirmaContrato(true, res.errorDetails, res.result);
            }
        });
}
